module.exports = __webpack_public_path__ + "static/media/05.7b7424f6.jpg";